<div class="external-modal">
  <div class="modal">
    <div class="mg-back-close-container end">
      <button
        mat-icon-button
        [disableRipple]="true"
        (click)="closeCancelModal()"
        aria-label="back"
        color="primary"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-content">
      <div class="iframe-container">
        <div
          class="iframe-content"
          [ngClass]="isSpinnerLoading ? 'show' : 'hidden'"
        >
          <div class="spinner-overlay">
            <div class="spinner-container">
              <div class="spinner-background"></div>
              <img src="assets/images/spinner.gif" alt="spinner" />
            </div>
          </div>
        </div>
        <div
          class="iframe-content"
          [ngClass]="isSpinnerLoading ? 'hidden' : 'show'"
        >
          <iframe class="iframe" [src]="externalUrl"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>
